import { MensagemService } from 'maestro-ng';
import { Injectable, Input } from '@angular/core';

@Injectable()
export class FonteDadosMensagemErroService {
  @Input() mensagensDeErro: {}[] = [];

  mostrarModalDeErros = false;

  constructor(
    private mensagemService: MensagemService
  ) {}

  public apresentarErro (mensagemErroPadrao, titulo, errorResponse, erroPersonalizado?) {
    if (errorResponse.status >= 500) {
      this.mensagensDeErro.push({ nome: titulo, erro: erroPersonalizado ? erroPersonalizado : errorResponse.error });
      this.mostrarModalDeErros = true;
    }
    else {
      this.mensagemService.addErro(mensagemErroPadrao, erroPersonalizado ? erroPersonalizado : errorResponse.error);
    }
  }

}
